export const FIREHOUSE_INSIDERS_PROGRAM_NAME = 'Firehouse Subs Insiders';

export const FIREHOUSE_INSIDERS_INFO_URL = '/firehouse-subs-insiders?source=my-account';

export const FIREHOUSE_INSIDERS_TERMS = 'Firehouse Subs Insiders Terms';

export const FIREHOUSE_INSIDERS_TERMS_URL = '/firehouse-subs-insiders-terms';

export const FIREHOUSE_INSIDERS_ARIA_LABEL = `I want to join ${FIREHOUSE_INSIDERS_PROGRAM_NAME}, consent to receiving occasional invites to surveys or focus groups via email and acknowledge that I have read and agree to the ${FIREHOUSE_INSIDERS_TERMS}`;
